/**
 * Feed API Service
 * Handles all feed-related API calls with retry logic and timeout handling
 * Uses centralized API configuration
 */

import axiosInstance from '../config/axiosInstance';
import { API_BASE_URL } from '../config/apiConfig';

// Configure axios defaults for better mobile performance
const axiosConfig = {
  timeout: 10000, // 10 second timeout
  withCredentials: true
};

// Retry logic for failed requests
const retryRequest = async (requestFn, retries = 2) => {
  for (let i = 0; i <= retries; i++) {
    try {
      return await requestFn();
    } catch (error) {
      if (i === retries || error.response) {
        // Don't retry if we got a response (4xx, 5xx) or exhausted retries
        throw error;
      }
      // Wait before retry (exponential backoff)
      await new Promise(resolve => setTimeout(resolve, Math.pow(2, i) * 500));
    }
  }
};

// Get For You feed
export const getForYouFeed = async (page = 1, limit = 20, debug = false) => {
  return retryRequest(async () => {
    const response = await axiosInstance.get('/feed/for-you', {
      ...axiosConfig,
      params: { page, limit, debug }
    });
    return response.data;
  });
};

// Get Following feed
export const getFollowingFeed = async (page = 1, limit = 20, debug = false) => {
  return retryRequest(async () => {
    const response = await axiosInstance.get('/feed/following', {
      ...axiosConfig,
      params: { page, limit, debug }
    });
    return response.data;
  });
};

// Get Explore feed
export const getExploreFeed = async (page = 1, limit = 20, debug = false) => {
  return retryRequest(async () => {
    const response = await axiosInstance.get('/feed/explore', {
      ...axiosConfig,
      params: { page, limit, debug }
    });
    return response.data;
  });
};

// Get Community feed
export const getCommunityFeed = async (page = 1, limit = 20, debug = false) => {
  return retryRequest(async () => {
    const response = await axiosInstance.get('/feed/community', {
      ...axiosConfig,
      params: { page, limit, debug }
    });
    return response.data;
  });
};